'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _identity2 = require('lodash/identity');
var _identity3 = _interopRequireDefault(_identity2);
var _some2 = require('lodash/some');
var _some3 = _interopRequireDefault(_some2);
var _gte2 = require('lodash/gte');
var _gte3 = _interopRequireDefault(_gte2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
exports.default = accessors;
var _constants = require('../utils/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    x: function x(datum) {
      return datum.x;
    },
    y: function y(datum) {
      return datum.y;
    },
    highlightIndex: function highlightIndex(datum) {
      return (0, _get3.default)(datum, 'highlightIndex', _constants.DEFAULT_HIGHLIGHT_INDEX);
    },
    isHighlighted: function isHighlighted(datum) {
      return (0, _gte3.default)(datum.highlightIndex, 0);
    },
    baselineIndex: function baselineIndex(datum) {
      return (0, _get3.default)(datum, 'baselineIndex', _constants.DEFAULT_BASELINE_INDEX);
    },
    isABaseline: function isABaseline(datum) {
      return (0, _gte3.default)(datum.baselineIndex, 0);
    },
    isFocused: function isFocused(datum) {
      return (0, _some3.default)([target.accessors.isHighlighted(datum), target.accessors.isABaseline(datum)], _identity3.default);
    },
    focusData: function focusData(datum) {
      if (target.accessors.isABaseline(datum)) return {
        index: target.accessors.baselineIndex(datum),
        type: _constants.BASELINE
      };else if (target.accessors.isHighlighted(datum)) return {
        index: target.accessors.highlightIndex(datum),
        type: _constants.HIGHLIGHT
      };
      return {
        index: 0
      };
    }
  });
}